<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <section>
        <!-- 焦点图 -->
        <div class="banner-box">
          <K-Swiper :datas="datas.focus" v-if="datas.focus && datas.focus_pics_is_show == 1"></K-Swiper>
        </div>

        <div class="box">
          <div class="code">
            <div>国家OID注册中心</div>
            <div v-text="datas.business.company_idcode"></div>
            <div>工信部授权的标识体系，全球可查验</div>
          </div>
          <div class="logo">
            <img :src="datas.business.logo" />
          </div>

          <!-- 产品信息 -->
          <div class="head-title">产品信息</div>
          <div><img class="img" :src="datas.product.img" /></div>
          <div class="list">
            <K-Form mold="Guldan" align="right" :datas="formObj.formProduct"></K-Form>
          </div>

          <!-- 商户信息 -->
          <div class="head-title">商户信息</div>
          <div class="list">
            <K-Form mold="Guldan" align="right" :datas="formObj.formBusiness"></K-Form>
          </div>

          <!-- 商户简介 -->
          <div class="head-title">商户简介</div>
          <div class="list">
            <K-Form mold="Guldan" align="right" :datas="formObj.formBusinessAttribute"></K-Form>
          </div>

          <!-- 视频信息 -->
          <div class="head-title">视频信息</div>
          <div class="list">
            <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox"
              :poster="datas.video.url + '?vframe/jpg/offset/1/w/400/'">
              <source :src="datas.video.url" type="video/mp4">
            </video>
          </div>

          <!-- 自定义栏目 -->
          <template v-if="datas.ref && datas.ref_is_show == 1">
            <div v-for="(item, index) in datas.ref" v-bind:key="index">
              <div class="head-title">商品详情</div>
              <div class="list">
                <div v-for="(val, ix) in item.datas" v-bind:key="ix">
                  <p v-if="val.type == 0" v-text="val.data"></p>
                  <img v-else class="img" :src="val.data">
                </div>
              </div>
            </div>
          </template>

        </div>
      </section>

    </div>
  </div>
</template>

<script>
  import KLoading from '@/components/Loading.vue'
  import KAlertMsg from '@/components/AlertMsg.vue'
  import KForm from '@/components/Form.vue'
  import mixin from '../mixins/mixin.js'
  import KSwiper from '@/components/Swiper.vue'
  export default {
    name: 'Normal15',
    components: {
      KLoading,
      KAlertMsg,
      KForm,
      KSwiper,
    },
    mixins: [mixin],
    data() {
      return {
        formObj: {
          formProduct: {
            name: {
              label: '产品名称',
              value: ''
            },
            unit: {
              label: '规格',
              value: ''
            },
            period: {
              label: '保质期',
              value: ''
            },
            introduce: {
              label: '介绍',
              value: ''
            }
          },
          formBusiness: {
            name: {
              label: '生产商',
              value: ''
            },
            baddress: {
              label: '厂址',
              value: ''
            },
            linkman: {
              label: '联系人',
              value: ''
            },
            linkphone: {
              label: '联系电话',
              value: ''
            }
          },
          formBusinessAttribute: {
            attribute: {
              type: 'attribute',
              label: '自定义属性',
              value: ''
            }
          }
        }
      }
    },
    created() {
      document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF');
      this.initData();
    },
    methods: {
      async initData() {
        //判断是演示还是真实码标
        if (this.$route.query.type == "demo") {
          const pid = this.$route.query.pid; //产品ID
          const rid = this.$route.query.rid; //企业ID
          this.GetDemoDatas(pid, rid); //获取演示模板信息
        } else {
          await this.GetDatas(); //获取码标信息
          const product = this.datas.product; //产品信息
          const business = this.datas.business; //企业信息
          product.scan_count = this.datas.scan_count; //扫码次数
          product.scan_first_time = this.datas.scan_first_time; //扫码时间
          product.batch = this.datas.batch.name; //产品批次
          this.formObj.formBusinessAttribute.attribute.value = business.customize_data; //企业自定义属性
          this.setFormContent(this.formObj.formProduct, product); //产品表单内容
          this.setFormContent(this.formObj.formBusiness, business); //企业表单内容
          this.$nextTick(() => {
            if (this.datas.video) {
              this.initVideo();
            }
          })
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .img {
    display: block;
    width: 100%;
  }

  .box {
    padding: 0 20px;
    margin-top: 10px;
  }

  .code {
    text-align: center;
    padding: 15px 0;
    font-size: 1em;
    color: white;
    line-height: 25px;
    background-color: rgba(39, 69, 130, 1);
  }

  .logo img {
    width: 100%;
    display: block;
    margin: 10px 0;
  }

  .head-title {
    color: white;
    padding: 15px;
    font-size: 1em;
    margin-top: 10px;
    background-color: rgba(39, 69, 130, 1);
  }
</style>



// WEBPACK FOOTER //
// src/view/Normal15.vue